import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  tipo_documento_selected: {}, //seleccionara el objeto de la lista de magistrados
  tipo_documentos: []
};
export const mutations = {
  SELECT_TIPO_DOCUMENTO({ context }, tipo_documento) {
    return (state.tipo_documento_selected = Object.assign({}, tipo_documento));
  },
  FILL_TIPO_DOCUMENTOS({ context }, list_tipo_documentos) {
    let tipo_documentos = [];
    Object.entries(list_tipo_documentos).forEach(([key, val]) => tipo_documentos.push(val));
    return (state.tipo_documentos = tipo_documentos);
  }
};
export const actions = {
  GET_ALL_TIPO_DOCUMENTOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_TIPO_DOCUMENTOS", response.data.data.tipo_documentos);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_TIPO_DOCUMENTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_TIPO_DOCUMENTO({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_TIPO_DOCUMENTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllTipoDocumentos: state => {
    return state.tipo_documentos;
  }
};
